// components/RecentLoggedInUsers.jsx
import React from 'react';

const sampleRecentUsers = [
  { id: 1, firstName: 'Alice', lastName: 'Johnson', email: 'alice.j@example.com', lastLogin: '2024-01-15T14:30:00' },
  { id: 2, firstName: 'Bob', lastName: 'Williams', email: 'bob.w@example.com', lastLogin: '2024-01-15T13:45:00' },
  { id: 3, firstName: 'Carol', lastName: 'Davis', email: 'carol.d@example.com', lastLogin: '2024-01-15T12:20:00' },
  { id: 4, firstName: 'Dave', lastName: 'Miller', email: 'dave.m@example.com', lastLogin: '2024-01-15T11:10:00' },
  { id: 5, firstName: 'Eve', lastName: 'Garcia', email: 'eve.g@example.com', lastLogin: '2024-01-15T10:05:00' }
];

const RecentLoggedInUsers = () => {
    const formatRelativeTime = (dateString) => {
        const date = new Date(dateString);
        const now = new Date();
        const diffMs = now - date;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMins / 60);
        
        if (diffMins < 1) return 'Just now';
        if (diffMins < 60) return `${diffMins} min ago`;
        if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
        return date.toLocaleDateString();
    };

    return (
        <div className="dbmm-recent-users-container">
            <h3 className="dbmm-section-title">Recent Logins</h3>
            <div className="dbmm-recent-users-list">
                {sampleRecentUsers.map(user => (
                    <div key={user.id} className="dbmm-recent-user-item">
                        <div className="dbmm-user-avatar">
                            {user.firstName.charAt(0)}{user.lastName.charAt(0)}
                            </div>
                            <div className="dbmm-user-details">
                            <div className="dbmm-user-name">{user.firstName} {user.lastName}</div>
                            <div className="dbmm-user-email">{user.email}</div>
                        </div>
                        <div className="dbmm-user-login-time">
                            {formatRelativeTime(user.lastLogin)}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RecentLoggedInUsers;